import script from "./CircleLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CircleLoader.vue?vue&type=script&setup=true&lang=ts"

import "./CircleLoader.vue?vue&type=style&index=0&id=37deb904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37deb904"]])

export default __exports__